 
const initialState = {
  id:null,
  list:null,
    PatientRegisterDetails: null,
    PatientRegisterStatus: false,
    newFacilityStatus: false,
    message: null,
    PatientReqInfoStatus: false,
    PatientReqInfoList: null,

    facilityListStatus : false,
    getByPracticeStatus:false,
    getByDoctorStatus:false,
    getByLocationStatus:false,
    searchByAllStatus:false,

    facilityListDetails:null,
    getByPracticeDetails:null,
    getByDoctorDetails:null,
    getByLocationDetails:null,
    searchByAllDetails:null,


    getRecordsListDetails:null,
    getRecordsListStatus:false,

    getResponseTimeListDetails:null,
    getResponseTimeStatus:false,

    getAuthExpListDetails:null,
    getAuthExpStatus:false,
    
     
    getFacilityAddress : null,
    getFacilityAddressStatus:false,
     
    getApiCostDetails:null,
    getApiCostStatus:false,

    addPaymentSuccessStatus :false,

    getPaymentMethodsList:null,
    getPaymentMethodsListStatus:false,
    chargeFinalCostStatus: false,


    isDefaultCardStatus:false,
    isAutoPayStatus:false,
    isCostAgree:false,

    downloadRecordService:false,
    downloadRecordDetails:null,

    getOtherClassificationsDetails : null,
    getOtherClassificationsStatus : false,

    requestDetailsforFinalRequest : null,

     disbaleAccountstatus:false,
     enableAccountstatus:false,
     verifyOtpEnableAccStatus : false,
     paymentMethodNotAddedStatus:false

   };
  export default initialState;